import { useEffect } from 'react'
import { useRouter } from 'next/router'

import { setMerchantOrigin } from '@/sdk/merchantOrigin'

export function useSetMerchantOrigin(): void {
  const router = useRouter()

  useEffect(() => {
    // Popup/iframe flow: origin captured via zoid xprops
    const fromXprops = window?.xprops?.originPageUrl

    // Redirect flow: origin forwarded as query param from set_wallet SSR
    const raw = router.query?.merchantOrigin
    const fromQuery = Array.isArray(raw) ? raw[0] : raw
    const url = fromXprops || fromQuery

    if (url) {
      try {
        setMerchantOrigin(new URL(url).origin)
      } catch {
        console.warn('[CryptoPay] Invalid originPageUrl:', url)
      }
    }
  }, [router.query?.merchantOrigin])
}
